import { Platform } from '@fly/shared';
import { FlySvgSprite } from '@fly/svg';

interface PlatformIconProps {
  className?: string;
  size?: number;
}

export function getPlatformIcon(platform: Platform, props?: PlatformIconProps) {
  const { size = 18, className } = props ?? {};

  switch (platform) {
    case 'darwin':
      return (
        <FlySvgSprite
          name='apple'
          width={size}
          height={size}
          className={className}
        />
      );
    case 'win32':
      return (
        <FlySvgSprite
          name='windows'
          width={size}
          height={size}
          className={className}
        />
      );
    default:
      return null;
  }
}
